import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import './Inicio.css';
import './Secciones.css';

const Inicio = () => {
  useEffect(() => {
    const sections = document.querySelectorAll('.seccion');

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05 }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="inicio">
      {/* Sección 1: Imagen - Texto - Imagen */}
      <section className="seccion seccion1">
        <div className="seccion1-imagen">
          <img src="/images/seccion1background1.jpg" alt="Sección 1 Imagen 1" />
        </div>
        <div className="seccion1-texto">
          <h2>Bienvenidos a nuestra página</h2>
          <p>Conoce todo lo que tenemos para ofrecerte.</p>
        </div>
        <div className="seccion1-imagen">
          <img src="/images/seccion1background2.jpg" alt="Sección 1 Imagen 2" />
        </div>
      </section>

      {/* Sección 2: Fondo con mensaje y grupos de texto */}
      <section className="seccion seccion2" style={{ backgroundImage: 'url(/images/seccion2background.jpg)' }}>
      <div className="Inicioseccion2-overlay"></div>
        <div className="seccion2-texto">
          <h3>Nuestros principales servicios</h3>
          <p>Descubre cómo nuestras soluciones pueden mejorar la eficiencia de tu negocio.</p>
        </div>
        <div className="grupos-texto">
          <div className="grupo-texto">
            <h3>Digitaliza tu ERP</h3>
            <p>
              Lleva Sage 200 al siguiente nivel con nuestras aplicaciones web y móviles para Android y Apple.
              Descubre cómo optimizar tu ERP y sacar el máximo rendimiento a tu negocio.
            </p>
          </div>
          <div className="grupo-texto">
            <h3>Adaptaciones Sage 200 a medida</h3>
            <p>
              Ofrecemos desarrollos exclusivos para Sage 200, creados a lo largo de años de experiencia, ahora
              disponibles como soluciones paquetizadas con precio fijo. Simplifica la implementación y mejora tu ERP.
            </p>
          </div>
          <div className="grupo-texto">
            <h3>Desarrollos a medida</h3>
            <p>
              Tu negocio es único, y Sage 200 también puede serlo: creamos desarrollos a medida para cubrir
              cualquier requerimiento.
            </p>
          </div>
          <div className="grupo-texto">
            <h3>Consultoría de procesos</h3>
            <p>
              Conviértete en un experto en Sage 200: te ayudamos a aprovechar todo el potencial de tus módulos
              clave con nuestra consultoría especializada.
            </p>
          </div>
        </div>
        <div className="seccion2-texto-final">
          <i> <p>Transformamos tu experiencia con Sage 200</p>
          <p>Avanzamos juntos</p></i>
        </div>
      </section>

      {/* Sección 6: Texto base e imagen de fondo */}
      <section className="seccion seccion6">
        <div className="seccion6-imagen">
          <img src="/images/seccion6background.jpg" alt="Sección 6 Imagen" />
          </div>
          <div className="seccion6-overlay"></div>
        <div className="seccion6-texto">
          <h2>Explora más</h2>
          <p>Conoce más sobre nuestros proyectos y cómo podemos ayudarte a crecer.</p>
          <Link to="/contacto">
            <button className="btn-contacto">Contacto</button>
          </Link>
        </div>
      </section>

      {/* Sección 3: Texto a la izquierda e imagen superpuesta a la derecha */}
      <section className="seccion seccionizquierda">
        <div className="seccionizquierda-texto">
          <h2>¿Quiénes somos?</h2>
          <p>En Al-Andalus Feeling, somos especialistas en la implementación y personalización del ERP Sage 200. No vendemos el software, sino que nos dedicamos a optimizar
            su uso a través de formación, desarrollos a medida e integraciones web y móviles, ayudando a las empresas a sacar el máximo rendimiento de su inversión.</p>

        </div>
        <div className='sabermasizquierda'>
        <a href="/nosotros">Saber mas ➡</a>
        </div>
        <div className="seccionizquierda-imagen">
          <img src="/images/seccion3background.jpg" alt="Sección 3 Imagen" />
        </div>
      </section>

      {/* Sección 4: Imagen a la izquierda y texto a la derecha */}
      <section className="seccion seccionderecha">
        <div className="seccionderecha-imagen">
          <img src="/images/seccion4background.jpg" alt="Sección 4 Imagen" />
        </div>
        <div className="seccionderecha-texto">
          <h2>Nuestros valores</h2>
          <p>Compromiso, innovación y excelencia.</p>
        </div>
      </section>     

      {/* Sección 5: Imagen con texto superpuesto */}
      <section className="seccion seccion5" style={{ backgroundImage: 'url(/images/seccion5background.jpg)' }}>
        <div className="seccion5-texto">
          <h2>Contáctanos</h2>
          <p>Estamos aquí para ayudarte. Escríbenos y trabajemos juntos.</p>
        </div>
      </section>
    </div>
  );
};

export default Inicio;
